import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Home from './Home';
import SupportPage from './SupportPage';
import QuizMatchPrivacy from './QuizMatchPrivacy';
import MindwarPrivacy from './MindwarPrivacy';
import MindwarSupport from './MindwarSupport';
import ProjectDetail from './components/ProjectDetail';
import { HiMenu, HiX } from 'react-icons/hi';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <Router>
      <div className="app">
        {/* Navigation */}
        <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
          <div className="container">
            <Link to="/" className="logo">Huseyin Selman Atabek</Link>
            <button className="menu-btn" onClick={toggleMenu}>
              {isMenuOpen ? <HiX size={24} /> : <HiMenu size={24} />}
            </button>
            <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
              <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
              <li><a href="#about" onClick={() => setIsMenuOpen(false)}>About</a></li>
              <li><a href="#projects" onClick={() => setIsMenuOpen(false)}>Projects</a></li>
              <li><a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact</a></li>
            </ul>
          </div>
        </nav>

        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/quizmatchsupport" element={<SupportPage />} />
            <Route path="/quizmatchprivacy" element={<QuizMatchPrivacy />} />
            <Route path="/mindwar_privacy" element={<MindwarPrivacy />} />
            <Route path="/mindwar_support" element={<MindwarSupport />} />
            <Route path="/projects/:projectId" element={<ProjectDetail />} />
          </Routes>
        </main>

        <footer className="footer">
          <div className="container">
            <div className="footer-content">
              <div className="footer-section">
                <h3>Quick Links</h3>
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li><a href="#about">About</a></li>
                  <li><a href="#projects">Projects</a></li>
                  <li><a href="#contact">Contact</a></li>
                </ul>
              </div>
              <div className="footer-section">
                <h3>Contact</h3>
                <ul>
                  <li>Email: atabek@example.com</li>
                  <li>Phone: +90 555 123 4567</li>
                </ul>
              </div>
             
            </div>
            <div className="footer-bottom">
              <p>&copy; 2023 Atabek Selman All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
